const MAX_PIXEL_RATIO = 2

const loadPdfjs = async () => {
  const pdfjs = await import('pdfjs-dist/legacy/build/pdf.min.mjs')
  if (!pdfjs.GlobalWorkerOptions.workerSrc) {
    pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url).toString()
  }
  return pdfjs
}

export const renderPdf = async (container, url, { signal } = {}) => {
  const pdfjs = await loadPdfjs()
  if (signal?.aborted) return

  const loadingTask = pdfjs.getDocument({ url, isEvalSupported: false })
  signal?.addEventListener('abort', () => loadingTask.destroy(), { once: true })

  const pdf = await loadingTask.promise
  const pixelRatio = Math.min(window.devicePixelRatio || 1, MAX_PIXEL_RATIO)

  for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
    const page = await pdf.getPage(pageNumber)
    if (signal?.aborted) return

    const scale = container.clientWidth / page.getViewport({ scale: 1 }).width
    const viewport = page.getViewport({ scale: scale * pixelRatio })
    const canvas = document.createElement('canvas')
    canvas.width = Math.floor(viewport.width)
    canvas.height = Math.floor(viewport.height)
    canvas.style.display = 'block'
    canvas.style.width = '100%'
    canvas.style.marginBottom = '8px'
    container.appendChild(canvas)

    await page.render({ canvas, viewport }).promise
  }
}
